import type { Conversation } from '@/features/ai-chat/types/chat.types';
import { Box } from '@/shared/ui/layout/Box';
import { MenuItem } from '@/shared/ui/overlays/Menu';
import Typography from '@/shared/ui/typography/Text';

import { useHistoryRecord } from './useHistoryRecord';

const HistoryRecord = ({
  conversation,
  handleClose,
  index
}: {
  conversation: Conversation;
  handleClose: () => void;
  index: number;
}) => {
  const { timeAgo, handleClick } = useHistoryRecord(conversation, handleClose);

  return (
    <MenuItem
      sx={{ height: '40px' }}
      onClick={handleClick}
    >
      <Box
        sx={{
          display: 'flex',
          gap: '8px',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%'
        }}
      >
        <Typography
          sx={{
            flex: 1,
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          title={conversation.name}
        >
          {conversation.name || `My chat #${index + 1}`}
        </Typography>
        <Typography
          sx={{
            fontSize: '10px',
            color: 'gx.textDisabled',
            lineHeight: 1,
            flex: 'none'
          }}
        >
          {timeAgo} ago
        </Typography>
      </Box>
    </MenuItem>
  );
};

export default HistoryRecord;
